//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MeasureBuilder.js";
import "../no/SelectDisplayableObject.js";
import "../no/SelectObject.js";
let d=[[[0,"BaseEnd",1,"Point",0],[0,"BasePoint",1,"Point",0],[1,"Feature1",0,"SelectDisplayableObject",0],[1,"Feature2",0,"SelectDisplayableObject",0],[0,"IsExact",1,0],[1,"Object1",0,"SelectDisplayableObject",0],[1,"Object2",0,"SelectDisplayableObject",0],[0,"Objtype1",1,0],[0,"Objtype2",1,0],[0,"Orientation",1,0],[0,"ProtractorEnd",1,"Point",0],[0,"Ptype",1,0],[0,"Vector1",1,"Direction",0],[0,"Vector2",1,"Direction",0]],[],[]];
SPLM.MeasureAngleBuilder = class extends SPLM.MeasureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MeasureAngleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MeasureAngleBuilder.AngleType = Object.freeze({
    "ThreePoints" : "ThreePoints", "TwoObjects" : "TwoObjects", "ScreenPoints" : "ScreenPoints"});

SPLM.MeasureAngleBuilder.ProjectionType = Object.freeze({
    "Angle3d" : "Angle3d", "AngleXy" : "AngleXy", "TrueAngle" : "TrueAngle"});

SPLM.MeasureAngleBuilder.OrientationType = Object.freeze({
    "InnerAngle" : "InnerAngle", "OuterAngle" : "OuterAngle"});

SPLM.MeasureAngleBuilder.ObjectType = Object.freeze({
    "Object" : "Object", "Feature" : "Feature", "Vector" : "Vector"});

export default SPLM;